import React, { useEffect, useReducer, useRef, useState } from "react";
import style from "./EditPlanHeader.module.sass";
import searchIcon from "./assets/icon_search_white.svg";
import FilterOverlay from "./FilterOverlay/FilterOverlay";
import { debounce, triggerTextChange } from "../../../helpers";
import { reducer, initialState } from "./EditPlanHeaderState";
function EditPlanHeader(props) {
  const { id, district, translations, showFilters } = props;
  const [showFilterOverlay, setShowFilterOverlay] = useState(false);
  const [state, dispatcher] = useReducer(reducer, initialState);
  const [search, setSearch] = useState("");
  const filterBtnRef = useRef();
  const [nameParams, setNameParams] = useState("name=");
  const [filtersParams, setFiltersParams] = useState("");

  useEffect(() => {
    props.onChangeFilter(`${nameParams}&${filtersParams}`);
  }, [nameParams, filtersParams]);

  const handleSearchChange = (e) => {
    const word = e.target.value;
    setSearch(word);
    setNameParams("name=" + word);
  };

  const onChangeFilter = (filters = "") => {
    setFiltersParams(filters);
  };

  const openFilterOverlay = (e) => {
    e.stopPropagation();
    setShowFilterOverlay(() => !showFilterOverlay);
  };

  const hideFilterOverlay = () => {
    setShowFilterOverlay(false);
  };

  const renderSearchText = () => {
    return (
      <div className={`${style.searchText}`}>
        <img src={searchIcon} className={`${style.seachIcon}`} />
        <input
          type="text"
          className={`${style.searchTextForm}`}
          placeholder={translations?.buttons.search}
          onChange={handleSearchChange}
        />
      </div>
    );
  };

  const renderSearchFilter = () => {
    return (
      <div
        className={`${style.searchFilter}`}
        onClick={openFilterOverlay}
        ref={filterBtnRef}
      >
        {translations?.buttons.filters}
        {state.totFilters > 0 && <span>{state.totFilters}</span>}
      </div>
    );
  };

  return (
    <div className={`${style.EditPlanHeader}`}>
      <EditPlanHeaderContext.Provider
        value={{ state, dispatcher, hideFilterOverlay }}
      >
        <div className={`${style.EditPlanHeaderFilterContainer}`}>
          {renderSearchText()}
          {showFilters && renderSearchFilter()}
        </div>
        {showFilters &&
          <FilterOverlay
            visible={showFilterOverlay}
            onChangeFilter={onChangeFilter}
            filterBtnRef={filterBtnRef}
            id={id}
            district={district}
          />
        }

      </EditPlanHeaderContext.Provider>
    </div>
  );
}

EditPlanHeader.propTypes = {};

EditPlanHeader.defaultProps = { showFilters: true };

export const EditPlanHeaderContext = React.createContext({});

export default EditPlanHeader;
